import React, { useState } from 'react';
import './CreditSnippet.css';
import star from '../assets/star.png'
import { useLanguage, getCreditSnippetTranslation } from '../hooks/useLanguage';
import { useSelector } from 'react-redux';

function CreditSnippet({ setIsStripeModalOpen }) {
    const [hovered, setHovered] = useState(false);
    const [isSpanish] = useLanguage();
    const { current, usage, exportCost, loading, error } = useSelector(state => state.creditStats);

    if (loading) {
        return (
            <div className="flex items-center justify-center rounded-full shadow-mdd px-4 py-1 h-10 min-h-10">
                <span className="text-sm">...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex items-center justify-center rounded-full shadow-mdd px-4 py-1 h-10 min-h-10 bg-red-100">
                <span className="text-sm text-red-600">Error</span>
            </div>
        );
    }

    if (!current || !usage || !exportCost) {
        return null;
    }

    return (
        <div
            className="flex flex-col items-end font-sans overflow-visible max-h-14 h-14 relative"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <div className={`  ${(current?.remainingCredits > 50) ? ' green-gradient-2' : 'red-gradient-2'} flex items-center justify-center  rounded-full shadow-mdd px-4 py-1 h-10 min-h-10 font-medium cursor-pointer transition-colors`}>
                <img src={star} alt="Logo" className="h-5 star-flip-scale" /> 
                <span className="text-lg font-bold ml-2  w-max">
                    <span className='shine'>
                    {loading ? getCreditSnippetTranslation('loading', isSpanish) : error ? getCreditSnippetTranslation('error', isSpanish) : current?.remainingCredits ?? '--'}
                    </span>
                    <span className='text-[10px] opacity-50 font-normal leading-loose ml-1 relative bottom-[2px]'>/ {current?.totalCredits}</span>
                </span>

                <h1>
                    {(((current?.remainingCredits / current?.totalCredits) * 100) < (current?.totalCredits * 0.75))}
                </h1>
            </div>
            {hovered && !loading && !error && current && usage && exportCost && (
                <div className="absolute top-11 credit-snippet-hover-panel mt-2 bg-white dark:bg-zinc-800 text-zinc-900 dark:text-zinc-100 rounded-xl shadow-md px-6 py-5 min-w-[260px] flex flex-col gap-2 text-sm animate-fadeInCreditPanel">
                    <div className="text-left flex items-end justify-between gap-4">
                        <span className='text-sm leading-loose mb-[-2px] w-max'>
                          {getCreditSnippetTranslation('remainingCredits', isSpanish)}
                        </span>
                        <h1 className='w-max'><span className='text-2xl font-bold relative bottom-[-2px]'>{current.remainingCredits}</span> <span className='text-xs opacity-50 font-normal leading-loose'>/ {current.totalCredits}</span></h1>
                    </div>
                    <div className="w-full h-2 bg-zinc-200 dark:bg-zinc-700 rounded-full mt-0 mb-1 overflow-hidden" aria-label="Credits Progress" role="progressbar" aria-valuenow={current.remainingCredits} aria-valuemax={current.totalCredits} aria-valuemin={0}>
                        <div
                            className={`h-full transition-all duration-500 ${((current.remainingCredits < (current.totalCredits - 200)) ? 'green-gradient' : 'red-gradient')} `}
                            style={{ width: `${100 - ((current.remainingCredits / current.totalCredits) * 100)}%` }}
                        />
                    </div>
                    
                    <h2 className='text-left text-xs font-bold tracking-wider mt-2 opacity-50'>{getCreditSnippetTranslation('credits', isSpanish)}</h2>
                    <div className='grid grid-cols-2 text-sm'>
                        <div className="text-left flex flex-col">
                            <span>{getCreditSnippetTranslation('usedToday', isSpanish)}</span>
                            <span className='text-xl font-bold'>{Math.max(0, usage.spentToday)}</span>
                        </div>
                        <div className="text-left flex flex-col w-max">
                            <span>{getCreditSnippetTranslation('usedThisMonth', isSpanish)}</span>
                            <span className='text-xl font-bold'>{Math.max(0, usage.spentThisMonth)}</span>
                        </div>
                    </div>
                    <h2 className='text-left text-xs font-bold tracking-wider mt-2 opacity-50'>{getCreditSnippetTranslation('export', isSpanish)}</h2>
                    <div className='grid grid-cols-2 text-sm'>
                    <div className="text-left flex flex-col">
                            <span>{getCreditSnippetTranslation('total', isSpanish)}</span>
                            <span className='text-xl font-bold'>{exportCost.totalExports}</span>
                        </div>
                        <div className="text-left flex flex-col">
                            <span>{getCreditSnippetTranslation('averageCost', isSpanish)}</span>
                            <span className='text-xl font-bold'>{exportCost.averageExportCost}</span>
                        </div>
                    </div>
                    <button
                className="mt-4 text-center h-10 gap-2 py-2 px-5 rounded-full !bg-secondary hover:!bg-secondary/80 text-default font-semibold"
                onClick={() => setIsStripeModalOpen(true)}
              >
                {getCreditSnippetTranslation('buyCredits', isSpanish)}
              </button>
                </div>
            )}
            {hovered && error && (
                <div className="credit-snippet-hover-panel mt-2">
                    <span>{error}</span>
                </div>
            )}
             
        </div>
    );
}

export default CreditSnippet; 